'use strict';
import i18n from 'i18next';
import { api } from '../../utils/api-interceptor';
import { Utils } from '../../utils/utils';

let servicesnoPeninsulares = (() => {
  let init = (e) => llamarServicio(e);

  let archivesData = (params) => getArchives(params);

  let dataNumber = (e, id, date) => getDataNumber(e, id, date);

  let modalData = (e, id, date) => getModaldata(e, id, date);

  let moreData = (e, id, date) => getMoreData(e, id, date);

  const llamarServicio = async (e) => {
    const urlApi =
      `static_pages?slug=${i18n.t('routes.snp')}&temporal=` +
      Math.floor(Math.random() * 1000);

    try {
      const data = await api(urlApi, { hasLang: true });
      return data.content;
    } catch (error) {
      return undefined;
    }
  };

  const getTitles = async (e, id, date) => {
    let urlApi = `widgets/${id}`;
    if (date) {
      let dateFormart = date.replace(/ /g, '');
      const timezone = new Date().getTimezoneOffset() / 60;
      urlApi = `widgets/${id}?datetime=${dateFormart}T00%3A00%3A00${
        timezone <= 0 ? '+' + -1 * timezone : -1 * timezone
      }%3A00&locale=${e}`;
    }

    try {
      const data = await api(urlApi);
      return data.widget.indicators;
    } catch (error) {
      null;
    }
  };

  const getDataNumber = async (e, id, date) => {
    const urlApi = date
      ? `widgets/${id}?datetime=${date}&locale=${e}`
      : `widgets/${id}`;

    try {
      return api(urlApi).then((data) => {
        const indicators = data.widget.indicators;
        const description = data.widget.description;
        const name = data.widget.name;
        let urlAnalysis;
        const indicatorName = [];
        urlAnalysis = Utils.getUrlAnalysis(data.widget.main_indicators);

        return Promise.all(
          indicators.map((el) => {
            indicatorName.push(el.name);
            return api(`${el.url}`);
          })
        ).then((data) => {
          const newArray = data.map((ele, index) => {
            return {
              value: ele.indicator.values[0]?.value,
              step: ele.indicator?.step_type,
              id: ele.indicator?.id,
              print_values: ele.indicator.values,
              short_name: ele.indicator?.short_name,
              name: ele.indicator?.name,
              nameT: indicatorName[index],
              geo_id: ele.indicator.geos[0]?.geo_id,
              geo_name: ele.indicator.geos[0]?.geo_name,
              datetime:
                id == 43
                  ? ele.indicator.values[ele.indicator.values.length - 1]
                      ?.datetime
                  : ele.indicator.values[0]?.datetime,
              urlAnalysis,
              description,
              name,
            };
          });
          return newArray;
        });
      });
    } catch (error) {}
  };

  const getErniDataFromWidget = async (params) => {
    const { lang, globalState, day, month, year, geo_id, widgetId } = params;
    let newmonth = month;
    let widget = '42';

    // Si el datepicker está en un mes/año futuro, las llamadas a la API deben construirse
    // como si el datepicker estuviera "hoy" (para evitar pedir rangos futuros sin datos).
    // Se aplica SOLO cuando (año, mes) está en el futuro respecto a hoy.
    const today = new Date();
    const selectedYear = parseInt(year, 10);
    const selectedMonth = parseInt(month, 10); // 1..12
    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth() + 1; // 1..12

    const isFutureMonthOrYear =
      selectedYear > todayYear ||
      (selectedYear === todayYear && selectedMonth > todayMonth);

    // Si es futuro, sustituimos day/month/year por los de hoy (simula datepicker hoy)
    // Manteniendo el mismo formato (2 dígitos en día/mes).
    let effectiveYear = year;
    let effectiveMonth = month;
    let effectiveDay = day;

    if (isFutureMonthOrYear) {
      effectiveYear = String(todayYear);
      effectiveMonth = String(todayMonth).padStart(2, '0');
      effectiveDay = String(today.getDate()).padStart(2, '0');
      newmonth = effectiveMonth;
    }

    if (globalState === '00:00') {
      if (widgetId != null && widgetId == 'widget43') {
        widget = '43';
      }
      // Obtener el mes actual (del effective date)
      const currentDate = today;
      const currentMonth = String(todayMonth).padStart(2, '0');

      // Comparar y restar un mes si es el mismo mes
      if (currentMonth === effectiveMonth) {
        let previousMonth = (parseInt(effectiveMonth, 10) - 1)
          .toString()
          .padStart(2, '0');

        // Si el resultado es 0 (enero -> diciembre)
        if (previousMonth === '00') {
          previousMonth = '12';
        }

        // newmonth = previousMonth;
      }
      if (effectiveMonth > currentMonth && currentDate.getFullYear() == year) {
        let previousMonth = (parseInt(currentMonth, 10) - 1)
          .toString()
          .padStart(2, '0');

        if (previousMonth === '00') {
          previousMonth = '12';
        }

        newmonth = previousMonth;
      }
      return api(
        `widgets/43?locale=${lang}&datetime=${
          effectiveYear.replace(/ /g, '') +
          '-' +
          newmonth.replace(/ /g, '') +
          '-' +
          '01'.replace(/ /g, '')
        }`
      ).then((data) => {
        const indicators = data.widget.indicators;
        const slug = data.widget.id;
        const description = data.widget.description;
        const name = data.widget.name;
        const magnituds = [];
        const alias = [];
        const indicatorName = [];
        const shortName = [];
        return Promise.all(
          indicators.map((el) => {
            magnituds.push(el.display_options);
            alias.push(el.alias);
            shortName.push(el.short_name);
            indicatorName.push(el.name);
            return api(`${el.url}&locale=${lang}`);
          })
        ).then((data) => {
          const indicators = data.map((ele, index) => {
            const values = ele.indicator.values.map((el) => {
              const dateOriginal = new Date(el.datetime);
              // Obtener el offset en minutos entre UTC y Madrid para la fecha dada
              const madridTime = dateOriginal.toLocaleString('en-US', {
                timeZone: 'Europe/Madrid',
              });
              const madridDate = new Date(madridTime);
              const offsetMinutes =
                (madridDate.getTime() - dateOriginal.getTime()) / (60 * 1000);
              const dateMadrid = new Date(
                dateOriginal.getTime() + offsetMinutes * 60 * 1000
              );
              return {
                x: dateMadrid,
                y: el.value,
              };
            });

            return {
              values,
              print_values: ele.indicator.values,
              time: ele.indicator.tiempo[0]?.id,
              alias: alias[index],
              display_options: magnituds[index],
              composited: ele.indicator?.composited,
              magnitud: ele.indicator?.magnitud,
              disaggregated: ele.indicator?.disaggregated,
              short_name: shortName[index],
              name: indicatorName[index],
              step: ele.indicator.step_type,
              id: ele.indicator.id,
              geo_id: ele.indicator.geos[0]?.geo_id,
              geo_name: ele.indicator.geos[0]?.geo_name,
            };
          });

          return {
            description,
            name,
            indicators,
            slug,
            // para que el render use la misma “fecha efectiva” que la API cuando el datepicker está en futuro
            effectiveDate: `${effectiveDay}-${effectiveMonth}-${effectiveYear}`,
            isFutureMonthOrYear,
          };
        });
      });
    } else {
      if (widgetId != null && widgetId == 'widget43') {
        widget = '43';
      }
      let timeInHours;
      typeof globalState == 'object'
        ? (timeInHours = globalState?.pages?.myp?.volumeHour)
        : (timeInHours = globalState);

      // FIX: evitar TypeError si la hora no viene informada
      // Normalizamos a string "HH:mm"
      if (typeof timeInHours !== 'string' || !timeInHours.includes(':')) {
        timeInHours = '00:00';
      }

      const timezone = new Date().getTimezoneOffset() / 60;
      // Obtener el mes actual
      const currentDate = new Date();
      const currentMonth = (currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0');
      // Comparar y restar un mes si es el mismo mes
      if (currentMonth === month) {
        let previousMonth = (parseInt(month) - 1).toString().padStart(2, '0');

        // Si el resultado es 0 (es decir, era enero), ajustar a diciembre del año anterior
        if (previousMonth === '00') {
          previousMonth = '12';
        }

        newmonth = previousMonth;
      }
      if (month > currentMonth) {
        let previousMonth = (parseInt(currentMonth) - 1)
          .toString()
          .padStart(2, '0');

        // Si el resultado es 0 (es decir, era enero), ajustar a diciembre del año anterior
        if (previousMonth === '00') {
          previousMonth = '12';
        }

        newmonth = previousMonth;
      }
      let newDate =
        effectiveYear +
        '-' +
        effectiveMonth +
        '-' +
        effectiveDay +
        'T' +
        timeInHours.split(':')[0] +
        ':00:00' +
        (timezone <= 0 ? '+' + -1 * timezone : -1 * timezone) +
        ':00';
      return api(`widgets/43?locale=${lang}&datetime=${newDate}`).then(
        (data) => {
          const indicators = data.widget.indicators;
          const slug = data.widget.id;
          const description = data.widget.description;
          const name = data.widget.name;
          const magnituds = [];
          const alias = [];
          const indicatorName = [];
          const shortName = [];
          return Promise.all(
            indicators.map((el) => {
              magnituds.push(el.display_options);
              alias.push(el.alias);
              shortName.push(el.short_name);
              indicatorName.push(el.name);
              return api(`${el.url}&locale=${lang}`);
            })
          ).then((data) => {
            const indicators = data.map((ele, index) => {
              const values = ele.indicator.values.map((el) => {
                const dateOriginal = new Date(el.datetime);
                // Obtener el offset en minutos entre UTC y Madrid para la fecha dada
                const madridTime = dateOriginal.toLocaleString('en-US', {
                  timeZone: 'Europe/Madrid',
                });
                const madridDate = new Date(madridTime);
                const offsetMinutes =
                  (madridDate.getTime() - dateOriginal.getTime()) / (60 * 1000);
                const dateMadrid = new Date(
                  dateOriginal.getTime() + offsetMinutes * 60 * 1000
                );
                return {
                  x: dateMadrid,
                  y: el.value,
                };
              });

              return {
                values,
                print_values: ele.indicator.values,
                time: ele.indicator.tiempo[0]?.id,
                alias: alias[index],
                display_options: magnituds[index],
                composited: ele.indicator?.composited,
                magnitud: ele.indicator?.magnitud,
                disaggregated: ele.indicator?.disaggregated,
                step: ele.indicator.step_type,
                id: ele.indicator.id,
                geo_id: ele.indicator.geos[0]?.geo_id,
                geo_name: ele.indicator.geos[0]?.geo_name,
              };
            });

            return {
              description,
              name,
              indicators,
              slug,
              // para que el render use la misma “fecha efectiva” que la API cuando el datepicker está en futuro
              effectiveDate: `${effectiveDay}-${effectiveMonth}-${effectiveYear}`,
              isFutureMonthOrYear,
            };
          });
        }
      );
    }
  };

  const getArchives = async (params) => {
    const { ambit, category, action, process, query } = params;

    const urlApi = `indicators?${
      ambit !== '' ? `taxonomy_ids[]=${ambit}&` : ''
    }${category !== '' ? `taxonomy_ids[]=${category}&` : ''}${
      action !== '' ? `taxonomy_ids[]=${action}&` : ''
    }${process !== '' ? `taxonomy_ids[]=${process}&` : ''}locale=${i18n.t(
      'routes.lng'
    )}${query ? `&text=${query}` : ''}`;

    let loading;
    let newIndicators;

    try {
      loading = true;
      const data = await api(urlApi);
      if (!ambit && !query && !category && !process && !action) {
        return {
          newIndicators: [],
          isLoading: loading,
        };
      }
      newIndicators = data.indicators
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        })
        .map((indicator) => {
          return {
            name: indicator.name,
            id: indicator.id,
          };
        });
      loading = false;
      return {
        isLoading: loading,
        newIndicators,
      };
    } catch (error) {
      null;
    }
  };

  const getModaldata = async (e, id, date) => {
    const urlApi = `widgets/${id}?datetime=${date}T00%3A00%3A00%2B02%3A00&locale=${e}`;

    try {
      const fetchResponse = await api(urlApi);
      return fetchResponse.widget.description;
    } catch (error) {
      null;
    }
  };

  const getMoreData = async (e, id) => {
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const usedDate = firstDay.toLocaleDateString();
    let formatDate = usedDate.split('/');
    const [d, m, y] = formatDate;

    const urlApi = `widgets/${id}?datetime=${y}-${m}-0${d}T00%3A00%3A00%2B02%3A00&locale=${e}`;

    try {
      const data = await api(urlApi);
      return data.widget.indicators;
    } catch (error) {
      null;
    }
  };

  const getDocumentData = async (params) => {
    const { lang } = params;
    return api(`widgets/49?locale=${lang}`).then((response) => {
      const data = {
        id: response.widget.id,
        name: response.widget.name,
        description: response.widget.description,
      };
      return data; // Asegúrate de retornar la data correctamente
    });
  };

  return {
    init,
    archivesData,
    dataNumber,
    modalData,
    moreData,
    getTitles,
    getErniDataFromWidget,
    getDocumentData: (params) => getDocumentData(params),
  };
})();

export { servicesnoPeninsulares };
